import type { IFieldState } from '@fff-web/fff-payments';
import * as styles from './textArea.module.scss';

type TextAreaProps = {
  id: string;
  label: string;
  placeholder: string;
  textStatus: IFieldState;
  maxLength?: number;
};

const TextArea = ({ id, label, placeholder, textStatus, maxLength }: TextAreaProps) => (
  <label htmlFor={id} className={styles.formTextAreaLabel}>
    {label}
    <>
      <textarea
        id={id}
        placeholder={placeholder}
        onChange={textStatus.changeHandler}
        onBlur={textStatus.blurHandler}
        value={textStatus.value}
        className={`${styles.formTextArea} ${textStatus.hasError ? styles.error : ''}`}
        maxLength={maxLength || undefined}
      />
    </>
  </label>
);

export default TextArea;
